import { ItemProps } from "app/frame/Navigation/interfaces";

export function getThirdLevel(navItems: ItemProps[] = [], depth = 0, parent?: ItemProps): ItemProps[] {
    return (
        navItems.reduce<ItemProps[] | undefined>((acc, item) => {
            if (acc) {
                return acc;
            }

            if (depth === 1 && parent && parent.children && item.children && item.children.length) {
                return parent.children.filter(c => c.children && c.children.length);
            }

            if (item.children && item.children.length) {
                const sub = getThirdLevel(item.children, depth + 1, item);
                if (sub.length) {
                    return sub;
                }
            }

            return acc;
        }, undefined) || []
    );
}

export function getBoundingClientX(Elem: Element): number {
    return Elem.getBoundingClientRect().x ? Elem.getBoundingClientRect().x : Elem.getBoundingClientRect().left;
}

export function getPositions(navItems: ItemProps[]): { [key: string]: number } {
    let parentX: number;

    return navItems.reduce<{ [key: string]: number }>((acc, item) => {
        const link = document.querySelector(`a[href="${item.url}"]`);

        if (!link) {
            return acc;
        }

        if (!parentX && link.parentElement) {
            parentX = getBoundingClientX(link.parentElement);
        }

        acc[item.url] = getBoundingClientX(link) - parentX;

        return acc;
    }, {});
}
